export default "__VITE_ASSET__DNM1hvlE__"